import { useNavigate, useParams } from "react-router";
import { Center, Container, Group, Select, Space } from "@mantine/core";
import { Logo } from "../../shared/svg";
import { ForgotPasswordPage } from "../../pages/forgot-password/ForgotPassword";
import { LinkSentPage } from "../../pages/link-sent/LinkSent";
import { SignInPage } from "../../pages/sign-in/SignIn";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useAuthStore from "../../store/useAuthStore";
import { setProfileLanguage } from "../../api/profileApi";
import useProfileStore from "../../store/useProfileStore";

interface Props {
  setMaxStep: (num: number) => void;
}

export const Login: FC<Props> = ({ setMaxStep }) => {
  const { page } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { access_token } = useAuthStore();
  const { getProfileLanguage } = useProfileStore();

  const handleLanguageChange = async (value: string | null) => {
    if (value) {
      i18n.changeLanguage(value);
      localStorage.setItem(
        "profileLanguage",
        JSON.stringify({ [value]: value })
      );

      if (access_token) {
        await setProfileLanguage(value);
        await getProfileLanguage();
      }
    }
  };

  const renderPage = () => {
    switch (page) {
      case "sign-in":
        return <SignInPage setMaxStep={setMaxStep} />;
      case "forgot-password":
        return (
          <ForgotPasswordPage onContinue={() => navigate("/login/link-sent")} />
        );
      case "link-sent":
        return <LinkSentPage />;
    }
  };

  return (
    <>
      <Group
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: 20,
        }}
      >
        <Select
          value={i18n.language}
          onChange={handleLanguageChange}
          data={[
            { value: "en", label: t("english") },
            { value: "uk", label: t("ukrainian") },
          ]}
          style={{ width: 150 }}
        />
      </Group>

      <Center mt={10} mb={50}>
        <Container size="sm" w={656}>
          <center>
            <Logo />
            <Space h="24px" />
            {renderPage()}
          </center>
        </Container>
      </Center>
    </>
  );
};
